import React from 'react';
import { Typography } from '@vtblife/uikit';

import classname from '@search/classname/src';

import { useRepairUserForm } from '../useRepairUserForm';

import './styles.css';

const cn = classname.bind(null, 'RepairLinks');

export const RepairLinks = ({
    openRepairModal
}: {
    openRepairModal: () => void;
}) => {
    const { meterPrice } = useRepairUserForm({});

    return (
        <div className={cn()}>
            <Typography variant='primary-alone' color='black-400'>
                Предчистовая отделка
            </Typography>
            <Typography variant='primary-alone' bold color='black-500'>
                {`от ${meterPrice} ₽/м²`}
            </Typography>
            <Typography
                variant='primary-alone'
                color='blue-500'
                bold
                className={cn('btn')}
                onClick={openRepairModal}
            >
                Рассчитать ремонт
            </Typography>
        </div>
    );
};
